import type { Route } from '../config/router'

export interface IntegrationContext {
  nextRoute: Route
}

export enum Integration {
  ApplePay = 'ApplePay',
}

export const CardImage: Record<Integration, string> = {
  [Integration.ApplePay]: 'cash-app-afterpay-visa-card.svg',
}
